import { useQuery } from "@tanstack/react-query";
import { useState } from "react";
import { toast } from "react-toastify";

import styles from "./HistoryPage.module.scss";

import { getHistoryTemplate } from "../../api/history/history";
import { DashBoardTablePlaceholder } from "../../components/DashBoards/DashBoardLayout/components/DashBoardTable";
import { EmptyHistoryReports } from "../../components/History/components/EmptyHistoryReports";
import { HeaderHistory } from "../../components/History/components/HeaderHistory";
import { HistoryTable } from "../../components/History/components/HistoryTable";
import { useUserData } from "../../hooks/useUserProfile";
import { useAppSelector } from "../../store/hooks/hooks";
import { selectIdHistory, selectName } from "../../store/slices/historySlice";
import { IActiveSyncLog } from "../../types/reports";
import { createErrorMessage } from "../../utils/createErrorMessage";

export const HistoryPage = () => {
  const [update, setUpdate] = useState("");

  const { organizationId, tenantId } = useUserData();
  const reportName = useAppSelector(selectName);
  const reportId = useAppSelector(selectIdHistory);

  const { data, isLoading, isFetched } = useQuery({
    queryKey: [
      "getCurrentSyncLogs",
      tenantId,
      organizationId,
      reportName,
      reportId,
      update,    
    ].filter(Boolean),
    queryFn: async () => {
      try {
        const res = await getHistoryTemplate(
          organizationId,
          tenantId
        );

        const allLogs = res.data.data;

        if (reportId) {
          const filteredLogs = allLogs.filter(
            (log: IActiveSyncLog) => log.entityIdentifier === reportId
          );
          return filteredLogs;
        }

        return allLogs;
      } catch (error) {
        toast.error(createErrorMessage(error));
      }
    },
    enabled: !!tenantId,
  });

  if (isLoading || !isFetched) {
    return (
      <div className={styles.root}>
        <HeaderHistory />
        <div style={{ padding: "40px 24px" }}>
          <DashBoardTablePlaceholder rows={5} />
        </div>
      </div>
    );
  }

  if (isFetched && !data?.length) {
    return (
      <div className={styles.root}>
        <HeaderHistory />
        <EmptyHistoryReports />
      </div>
    );
  }

  return (
    <div className={styles.root}>
      <HeaderHistory />
      <HistoryTable
        listTable={data}
        organizationId={organizationId}
        tenantId={tenantId}
        setUpdate={setUpdate}
      />
    </div>
  );
};
